import React, {useState, useEffect} from "react";
import { useSearchParams, useLocation, useParams } from "react-router-dom";
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import WazarenCard from "../components/wazaren/WazarenCard";
import WazarenCardSkeleton from "../components/wazaren/WazarenCardSkeleton";
import WazarenFilter from "../components/wazaren/WazarenFilter"
import { 
    Typography, CssBaseline, Box, Toolbar, Pagination, Grid, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { GetRecordDisplayed } from '../commonFunctions';
import * as CONSTANTS from "../constants";

import { view_wazarens } from "../services/topic_view";

const WazarenPage = () => {

    let {lang} = useParams();
    const location = useLocation();

    document.title = `${CONSTANTS.DRAWER.WAZAREN[lang]} - Wotagei Zone`

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    // hook
    const [maxPage, setMaxPage] = useState(1);
    const [maxRecords, setMaxRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [wazarens, setWazarens] = useState(null);
    const [loading, setLoading] = useState(true);
    const [drawerOpen, setDrawerOpen] = useState(false);
            
    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    // Load Params from URL
    const [searchParams, setSearchParams] = useSearchParams({
        'page': 1,
    });

    const handlePageChange = (event, curPage) => {
        searchParams.set('page', curPage)
        let filter = searchParams;
        setPage(curPage);
        setSearchParams(filter);
    };

    // Filter button
    const resetFilter = () => {
        let tempParams = {
            'page': 1,
        }
        setPage(1);
        setSearchParams(tempParams);
    }

    const submitFilter = (filter) => {
        setSearchParams(filter);
    }

    const fetchWazarens = async () => {
        setLoading(true);
        try {
            const [status, result] = await view_wazarens(lang, searchParams);
            if (status === 200) {
                setWazarens(result.wazarens);
                setMaxRecords(result.records_count);
                setMaxPage(
                    Math.ceil(result.records_count / 10)
                );
            }
        } catch (error) {
            console.error('Failed to fetch wazarens.');
        }
        setLoading(false);
    }
    
    // send api request for url changes
    useEffect(() => {
        fetchWazarens();
    }, [location]);

    return (
        <Box style={{height: '100vh'}}>
            <CssBaseline />
            <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
            <Box sx={{ display: 'flex'}} style={{height: '100vh'}}>
                <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3 }}>
                    <Toolbar />
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Typography 
                                variant="h5"
                                style={{
                                    textAlign: "left",
                                    fontWeight: "bolder",
                                }}
                            >
                                {CONSTANTS.DRAWER.WAZAREN[lang].toUpperCase()}
                            </Typography>
                            <Box 
                                pt={3} pb={3}
                            >
                                <Typography>
                                    {wazarens? GetRecordDisplayed(lang, maxRecords, page): ''}
                                </Typography>
                            </Box>

                            <Box pb={3}>
                                <Grid container spacing={3}>
                                    {
                                        wazarens?
                                        (wazarens.map((wazaren) => (                                  
                                            <Grid item xs={12} md={6}>
                                                <WazarenCard wazaren={wazaren} lang={lang}/>
                                            </Grid>
                                        )))
                                        :
                                        <>
                                            <Grid item xs={12} md={6}>
                                                <WazarenCardSkeleton />
                                            </Grid>
                                            {isMobile? 
                                                <></>
                                                :
                                                <Grid item xs={12} md={6}>
                                                    <WazarenCardSkeleton />
                                                </Grid>
                                            }
                                        </>
                                    }
                                </Grid>
                            </Box>
                            {/** Pagination */}
                            <Box 
                                display="flex" 
                                justifyContent="center"
                            >
                                <Pagination 
                                    count={maxPage} 
                                    shape="rounded" 
                                    showFirstButton
                                    showLastButton
                                    page={page}
                                    onChange={handlePageChange}
                                />
                            </Box> 
                        </Grid>

                        {/** Filters */}
                        <Grid item xs={12} md={4} style={{height: '80vh'}}>
                            <Box >
                                <Typography 
                                    pb={3}
                                    variant="h5" 
                                    style={{
                                        textAlign: "left",
                                        fontWeight: "bolder",
                                    }}
                                >
                                    {CONSTANTS.WAZAREN_FILTER.FILTER[lang].toUpperCase()}
                                </Typography>
                            </Box>
                            <Box pb={3}>
                                <WazarenFilter resetFilter={resetFilter} submitFilter={submitFilter} lang={lang} />
                            </Box>
                        </Grid>
                    </Grid>
                    
                </Box>
            </Box>
        </Box>
    );
};
 
export default WazarenPage;